"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshAccessTokenException = void 0;
class RefreshAccessTokenException extends Error {
    constructor() {
        super('RefreshAccessTokenError');
    }
}
exports.RefreshAccessTokenException = RefreshAccessTokenException;
//# sourceMappingURL=RefreshAccessTokenException.js.map